export default __webpack_public_path__ + "static/media/person.6de6d515.svg";